<template>
  <standard-dialog
    v-model="model"
    :title="formTitle"
    :subtitle="editedMenuType?.id ? `ID: ${editedMenuType.id}` : ''"
    icon="mdi-food-variant"
    @save="save"
    :disabled="loading || !valid"
    :loading="loading"
  >
    <v-form class="mt-4" v-model="valid">
      <text-field
        v-model="editedMenuType.name"
        :rules="[rules.required]"
        required
        :label="$t('title')"
      />
      <text-field
        type="number"
        v-model="editedMenuType.poredak"
        :label="$t('order_m')"
        :hint="$t('hi_num')"
        persistent-hint
      />
      <autocomplete
        :items="generalTypes"
        item-value="id"
        item-text="name"
        v-model="editedMenuType.general_type"
        :label="$t('global_type')"
      />
    </v-form>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import menuService from "@/services/menu";
import { generalTypes } from "@/models/menuType";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
  },
  props: {
    menuTypes: {
      type: Array,
      default: () => [],
    },
    menuType: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      editedMenuType: {},
    };
  },

  computed: {
    formTitle() {
      return this.isEdit ? this.$t("edit_menu_type") : this.$t("new_menu_type");
    },

    generalTypes() {
      return generalTypes.map((type) => ({
        ...type,
        name: this.$t(type.name),
      }));
    },
  },

  watch: {
    menuType: {
      handler(newVal) {
        this.editedMenuType = Object.assign({}, newVal);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async save() {
      if (!this.editedMenuType.name) {
        return;
      }

      this.loading = true;

      try {
        const menuTypeData = {
          name: this.editedMenuType.name,
          general_type: this.editedMenuType.general_type,
          poredak: this.editedMenuType.poredak || null,
        };

        if (this.isEdit) {
          const response = await menuService.updateMenuType(
            this.editedMenuType.id,
            menuTypeData
          );
          const updatedMenuType = { ...this.editedMenuType, ...response.data };
          this.showSuccessSnackbar(this.$t("menu_type_updated"));
          this.$emit("menu-type-updated", updatedMenuType);
          this.close();
        } else {
          const response = await menuService.createMenuType(menuTypeData);
          this.showSuccessSnackbar(this.$t("menu_type_created"));
          this.$emit("menu-type-created", response.data);
          this.close();
        }
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_saving_menu_type"));
        console.error("Error saving menu type:", error);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.loading = false;
      this.$emit("close");
      this.model = false;
      this.editedMenuType = {};
    },
  },
};
</script>

<style scoped>
.container-padding {
  padding-bottom: 5px;
}

.order-hint {
  margin-top: -20px;
  font-size: 10px;
}
</style>
